import Vue from 'vue'
import VueI18n from 'vue-i18n'

import jp from '~/locales/jp/index';
import en from '~/locales/en/index';

Vue.use(VueI18n)

export const i18n = new VueI18n({
  fallbackLocale: 'jp',
  messages: {
    jp, en
  },
  locale: 'jp'
})

export default ({ app, store }) => {
  // Set i18n instance on app
  // This way we can use it in middleware and pages asyncData/fetch
  i18n.locale = store.state.locale || 'jp';
  app.i18n = i18n;

  // app.i18n.path = (link) => {
  //   if (app.i18n.locale === app.i18n.fallbackLocale) {
  //     return `/${link}`
  //   }
  //
  //   return `/${app.i18n.locale}/${link}`
  // }
}
